// extracted by mini-css-extract-plugin
export var button = "modal-module--button--xNoK3";
export var content = "modal-module--content--D5Hgc";
export var icon = "modal-module--icon--qwzle";
export var label = "modal-module--label--94+BG";
export var overlay = "modal-module--overlay--f6eVO";